// Single source of truth for the backend API base URL. Always set VITE_API_URL at
// build time (see client/package.json's build:production script) -- the fallback
// below only matters for a local dev build that skipped setting it, and intentionally
// does NOT default to another deployment's backend URL.
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000';
